import { formatUIDate } from 'utils/helpers'

export const toDocumentsFormItemsList = documents =>
  documents.map(document => ({
    id: document.id,
    text: `${document.documentType.label} - ${formatUIDate(Date.now())} - ${
      document.images.length
    } imagini`
  }))
